import { Box, Container, Stack, Text, Loader } from "@mantine/core";
import { useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import useGetConvites from "@/components/app-container/useGetConvites";
import { getLicenciados } from "@/modules/projetos/firestore";
import Questionario from "@/modules/responder-questionario/components/questionario";
import QuestionarioV2 from "@/modules/responder-questionario/components/v2/Questionario";
import useGetQuestionarioConviteFromUrl from "@/modules/responder-questionario/hooks/useGetQuestionarioConviteFromUrl";
import { getCurrentUser } from "@/services/auth";
import useGetProjetoItem from "./useGetProjetoNew";

const message = "";

type ResponderQuestionarioPageParameters = {
  idEmpresa: string;
  colaboradorId?: string;
};

const ResponderQuestionarioPage = () => {
  const { idEmpresa, colaboradorId } = useParams<ResponderQuestionarioPageParameters>();

  const userId = useMemo(() => {
    return colaboradorId ?? getCurrentUser()?.uid ?? "";
  }, [colaboradorId]);

  const { data: empresaConvidada } = useGetConvites(userId);

  const [licenciado, setLicenciado] = useState<TLicenciado | null>(null);

  const { data: data, isFetching } = useGetQuestionarioConviteFromUrl({ activeEmpresaId: idEmpresa });

  const { data: projeto } = useGetProjetoItem({
    idProjeto: data?.idProjeto,
    empresaConvidada: empresaConvidada && empresaConvidada?.length > 0 ? true : false
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        await loadLicenciados();
      } catch (error) {
        console.error(message, error);
      }
    };

    void fetchData();
  }, [projeto?.licenciado]);

  const loadLicenciados = async () => {
    const arrayLicenciados = await getLicenciados(idEmpresa || "");
    const aux = arrayLicenciados.docs.map((desafio) => desafio.data());
    setLicenciado(aux.find((item) => item?.id === projeto?.licenciado) as TLicenciado);
  };

  if (isFetching) {
    return (
      <Container size="sm" py="xl">
        <Stack align="center" gap="md">
          <Text size="lg" fw={500} c="dimmed">
            Carregando questionário...
          </Text>
          <Loader size="md" />
        </Stack>
      </Container>
    );
  }

  if (!idEmpresa) {
    return (
      <Container size="sm" py="xl">
        <Stack align="center" gap="md">
          <Text size="lg" fw={500} c="red">
            Empresa não encontrada
          </Text>
          <Text size="sm" c="dimmed">
            Verifique se o link está correto e tente novamente.
          </Text>
        </Stack>
      </Container>
    );
  }

  if (data) {
    return (
      <Container fluid py="md">
        <Box
          style={{
            backgroundColor: "#f9f9f9",
            border: "1px solid #e0e0e0",
            borderRadius: "16px",
            padding: "24px",
            minHeight: "400px"
          }}
        >
          <QuestionarioV2
            licenciado={licenciado ?? undefined}
            questionario={data}
            empresaId={idEmpresa}
            colaboradorId={userId ?? ""}
          />
        </Box>
      </Container>
    );
  }

  return (
    <Container fluid py="md">
      <Box
        style={{
          backgroundColor: "#f9f9f9",
          border: "1px solid #e0e0e0",
          borderRadius: "16px",
          padding: "24px",
          minHeight: "400px"
        }}
      >
        <Questionario data={data} licenciado={licenciado as TLicenciado} />
      </Box>
    </Container>
  );
};

export default ResponderQuestionarioPage;
